import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { authInterceptor } from './app/core/http/auth.interceptor';
import { localeInterceptor } from './app/core/http/locale.interceptor';
import { translocoProviders } from './app/core/i18n/transloco.config';
import { loadGoogleMapsScript } from './load-google-maps';

if (environment.production) {
  enableProdMode();
}

function bootstrap(): void {
  platformBrowserDynamic()
    .bootstrapModule(AppModule, {
      applicationProviders: [
        provideZoneChangeDetection(),
        provideHttpClient(withInterceptors([localeInterceptor, authInterceptor])),
        ...translocoProviders,
      ],
    })
    .catch(err => console.error(err));
}

loadGoogleMapsScript()
  .catch(() => console.warn('Google Maps: sem chave ou falha ao carregar (mapas podem ficar em branco).'))
  .finally(() => bootstrap());
